import type { ReactNode } from "react";

import { chipLevelClass } from "../modules/connection-stats/ui/labels";
import styles from "./StatusChip.module.scss";

export interface StatusChipValueSplit {
  metric: ReactNode;
  qual?: ReactNode;
}

export interface StatusChipProps {
  id?: string;
  icon: string;
  label: string;
  value?: ReactNode;
  valueSplit?: StatusChipValueSplit;
  valueVariant?: "rtt" | "loss";
  level: string | null | undefined;
  hint?: ReactNode;
  spark?: ReactNode;
}

export function StatusChip({
  id,
  icon,
  label,
  value,
  valueSplit,
  valueVariant,
  level,
  hint,
  spark,
}: StatusChipProps) {
  const levelClass = styles[chipLevelClass(level)] ?? "";
  const valueClass = [styles.value, valueVariant ? styles[valueVariant] : ""]
    .filter(Boolean)
    .join(" ");
  const rootClass = [styles.root, levelClass].filter(Boolean).join(" ");

  return (
    <span className={rootClass} id={id} tabIndex={0}>
      <i className={`bi ${icon}`} />
      <span className={styles.label}>{label}</span>
      {spark ? <span className={styles.spark}>{spark}</span> : null}
      {valueSplit ? (
        <span className={`${valueClass} ${styles.split}`}>
          <span className={styles.metric}>{valueSplit.metric}</span>
          {valueSplit.qual ? <span className={styles.qual}>{valueSplit.qual}</span> : null}
        </span>
      ) : (
        <span className={valueClass}>{value}</span>
      )}
      <span className={styles.hint} role="tooltip">
        {hint}
      </span>
    </span>
  );
}
